import 'plugins';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import 'antd/dist/antd.css';
import 'styles/antd.less';
import 'styles/main.less';
import App from './App';
import { unregister } from './serviceWorker';
import { configureStore } from './store';

const { store, persistor } = configureStore();

render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

unregister();
